import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/use-auth-store';
import { shiftReportsApi } from './api';
import type { SessionBillRow, ShiftReportFilters, ShiftReportResponse } from './types';

function useTenantId(): string {
  return useAuthStore((s) => s.profile?.tenant_id ?? 'anonymous');
}

export function useShiftReports(filters: ShiftReportFilters): UseQueryResult<ShiftReportResponse> {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: ['shift-reports', tenantId, filters],
    queryFn: () => shiftReportsApi.list(filters),
    staleTime: 30_000,
  });
}

export function useSessionBills(
  attendanceId: string | null,
): UseQueryResult<SessionBillRow[]> {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: ['shift-reports', tenantId, 'session-bills', attendanceId],
    queryFn: () => shiftReportsApi.bills(attendanceId as string),
    enabled: !!attendanceId,
    staleTime: 30_000,
  });
}
